'use client';

import { useEffect, useRef } from 'react';

export const usePanelSwapFocus = (hasResult: boolean) => {
  const formRef = useRef<HTMLFormElement>(null);
  const summaryRef = useRef<HTMLDivElement>(null);
  /** Prevents the initial render from claiming focus. */
  const panelSwapped = useRef(false);

  const markPanelSwap = (swapped = true) => {
    panelSwapped.current = swapped;
  };

  // A panel swap unmounts its triggering button and drops focus to <body>.
  useEffect(() => {
    if (!panelSwapped.current) return;

    panelSwapped.current = false;
    (hasResult ? summaryRef.current : formRef.current)?.focus();
  }, [hasResult]);

  return { formRef, summaryRef, markPanelSwap };
};
